import PropTypes from 'prop-types'
import React from 'react'
import classes from './ActivityAction.module.scss'

export class ActivityAction extends React.Component {
  static propTypes = {
    icon: PropTypes.node,
    className: PropTypes.string
  }

  render () {
    const {
      children,

      icon,
      className,

      ...props
    } = this.props

    let compClassName = classes.action
    if (className) compClassName += ' ' + className

    return (
      <span
        {...props}
        className={compClassName}
      >
        {icon &&
          React.cloneElement(icon, {
            className: icon.props.className ? icon.props.className + ' ' + classes.icon : classes.icon
          })
        }
        {children}
      </span>
    )
  }
}

export default ActivityAction

